module.exports = __webpack_public_path__ + "img/stu.c2cad7c2.png";